import { components } from "@/api-schema";
import { CustomerAddressType } from "@/api-schema-enums";
import { RowWithIdentifier } from "@/components/data-table/_helpers/row-identifier";

type CustomerTableType = components["schemas"]["Customer"] & RowWithIdentifier;
type Address = components["schemas"]["Address"];

export const getBillingAddress = (customer: CustomerTableType): Address | null => {
  const billing = customer.addresses?.find((entry) => entry.type === CustomerAddressType.Billing);

  return billing?.address ?? null;
};
